import { __exportAll } from "../_virtual/_rolldown/runtime.js";
//#region src/utils/menu_item_utils.ts
var menu_item_utils_exports = /* @__PURE__ */ __exportAll({
	getModGroupIdSet: () => getModGroupIdSet,
	getModGroupIdSetForPriceOption: () => getModGroupIdSetForPriceOption,
	getPriceOptionWithId: () => getPriceOptionWithId,
	isCompoundItem: () => isCompoundItem,
	isHidden: () => isHidden
});
function getModGroupIdSet(data) {
	return data.priceOptions.reduce((modGroupIdSet, priceOption) => {
		return {
			...modGroupIdSet,
			...getModGroupIdSetForPriceOption(priceOption)
		};
	}, {});
}
function getModGroupIdSetForPriceOption(priceOption) {
	const modGroupIdSet = {};
	priceOption.addonSetIds?.forEach((modGroupId) => {
		modGroupIdSet[modGroupId.toString()] = modGroupId;
	});
	priceOption.floatingModGroupIds?.forEach((modGroupId) => {
		modGroupIdSet[modGroupId.toString()] = modGroupId;
	});
	return modGroupIdSet;
}
function getPriceOptionWithId(data, poId) {
	return data.priceOptions.find((po) => {
		return po._id.equals(poId);
	});
}
function isCompoundItem(itemData) {
	return Array.isArray(itemData?.constituentItems);
}
function isHidden(data) {
	return data.priceOptions.every((po) => {
		return !!po.hiddenState || !!po.i9nHiddenState;
	});
}
//#endregion
export { getModGroupIdSet, getModGroupIdSetForPriceOption, getPriceOptionWithId, isCompoundItem, isHidden, menu_item_utils_exports };

//# sourceMappingURL=menu_item_utils.js.map